import { DateRangeFilterDescriptor } from 'bringg-web/features/filter-bar/types';

export const DATE_RANGE_FILTERS: DateRangeFilterDescriptor[] = [
	{
		outputField: 'dates',
		inputField: {
			start: 'timeWindowStart',
			end: 'timeWindowEnd'
		}
	},
	{
		outputField: 'sla',
		inputField: {
			start: 'slaStartTime',
			end: 'slaEndTime'
		}
	},
	{
		outputField: 'reservedUntil',
		inputField: {
			start: 'reservedUntilStartTime',
			end: 'reservedUntilEndTime'
		}
	}
];

export const DYNAMIC_DATE_TIME_RANGES_FF = 'enable_dynamic_date_time_ranges';
